/* This file is autogenerated, see readme.md for instructions */
import UnarchiveAltSvgIcon from '@bloomreach/banana-theme/icons/unarchive-alt.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const UnarchiveAltIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <UnarchiveAltSvgIcon />
    </Icon>
  );
});

UnarchiveAltIcon.displayName = 'UnarchiveAltIcon';

export default UnarchiveAltIcon;
